import { query, request } from 'src/utils/request';
import { stringify } from 'qs';

// 获取下拉框枚举值
export const getAssetConfig = (data) => {
  return query('/zlb/budget/api/asset/common/select-config', { 
    method: 'POST',
    data
  });
};

// 资产变更计划单据列表
export const getAssetList = (data) => {
  return query('/zlb/budget/api/asset/apply-form/paging', { 
    method: 'POST',
    data
  });
};

// 查询采购目录层级
export const getPurchaseDirectory = (params) => {
  return query(`/zlb/budget/api/asset/apply-form/purchase-directory/${params.purchaseType}`);
};

// 保存资产更新计划单据
export const saveAsset = (data) => {
  return query('/zlb/budget/api/asset/apply-form/save', { 
    method: 'POST',
    data
  });
};

// 提交资产更新计划单据
export const submitAsset = (data) => {
  return query('/zlb/budget/api/asset/workflow/submit', { 
    method: 'POST',
    data
  });
};

// 获取申请单默认信息
export const getDefaultInfo = (params) => {
  return query(`/zlb/budget/api/asset/apply-form/default-info/${params.formBizType}`);
};

// 获取单据详情
export const getAssetInfo = (params) => {
  return query(`/zlb/budget/api/asset/apply-form/info?${stringify(params)}`);
};

// 删除资产更新计划单
export const deleteAsset = (data) => {
  return query('/zlb/budget/api/asset/apply-form/delete', { 
    method: 'POST',
    data 
  });
};

// 查询工作流模板
export const getWorkflowTemplate = (data) => {
  return query('/zlb/budget/api/asset/workflow/getTemplate', {
    method: 'POST', 
    data,
  });
};

// 查询工作流实例
export const getWorkflowInstance = (data) => {
  return query('/zlb/budget/api/asset/workflow/getInstance', {
    method: 'POST', 
    data,
  });
};

// 提交审批
export const submitWorkflow = (data) => {
  return query('/zlb/budget/api/asset/workflow/submit', {
    method: 'POST', 
    data,
  });
};

// 审批工作流
export const auditWorkflow = (data) => {
  return request('/zlb/budget/api/asset/workflow/audit', {
    method: 'POST', 
    data,
  });
};

// 撤回工作流
export const canceWlorkflow = (data) => {
  return query('/zlb/budget/api/asset/workflow/cancel', {
    method: 'POST', 
    data,
  });
};

// 申请单作废
export const nullifyAsset = (data) => {
  return query('/zlb/budget/api/asset/apply-form/nullify', {
    method: 'POST', 
    data,
  });
};

// 申请单转交
export const forwardAsset = (data) => {
  return query('/zlb/budget/api/asset/apply-form/forward', {
    method: 'POST', 
    data,
  });
};
